<template>
  <div class="row">
    <div class="row__empty"></div>
    <div :class="['row__column', columns[1].tag]">
      <p>
        {{ `#${index + 1}` }}
      </p>
    </div>

    <div v-for="(col, idx) in columns.slice(2)" :key="idx" :class="['row__column', col.tag]">
      <div>
        <!-- Колонка статуса -->
        <component-is-status v-if="col.renderer === 'status'" :obj="obj" />
        <!-- Колонка дат -->
        <component-prepare-date v-else-if="col.renderer === 'date'" :timestamp="obj[col.tag]" />
        <!-- Колонка с прогрессом -->
        <component-percent v-else-if="col.renderer == 'progress'" :percent="obj[col.tag]" />
        <!-- Колонка с информацией -->
        <a-button
          v-else-if="col.renderer === 'info'"
          type="primary"
          size="small"
          @click="$emit('openModal', obj[col.tag])"
        >
          Подробнее
        </a-button>
        <!-- Колонка с действиями -->
        <component-column-actions
          v-else-if="col.renderer === 'actions'"
          :data="obj"
          @clickStop="$emit('clickStop', $event)"
          @clickRestart="$emit('clickRestart', $event)"
        />
        <!-- Колонка остальное -->
        <p v-else class="file-page__column-text">
          {{ obj[col.tag] }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
//
// import gql from 'graphql-tag';
// import { print } from 'graphql';

// const gqlConfRun = gql`
//   mutation ExecutePipeline(
//     $repositoryLocationName: String!
//     $repositoryName: String!
//     $pipelineName: String!
//     $runConfigData: RunConfigData!
//     $mode: String!
//   ) {
//     launchPipelineExecution(
//       executionParams: {
//         selector: {
//           repositoryLocationName: $repositoryLocationName
//           repositoryName: $repositoryName
//           pipelineName: $pipelineName
//         }
//         runConfigData: $runConfigData
//         mode: $mode
//       }
//     ) {
//       __typename
//       ... on LaunchPipelineRunSuccess {
//         run {
//           runId
//         }
//       }
//       ... on PipelineConfigValidationInvalid {
//         errors {
//           message
//           reason
//         }
//       }
//       ... on PythonError {
//         message
//       }
//     }
//   }
// `;

export default {
  name: 'ComponentHelperRow',

  components: {
    ComponentPrepareDate: () => import('../PrepareDate.vue'),
    ComponentIsStatus: () => import('../IsStatus.vue'),
    ComponentColumnActions: () => import('../ColumnActions.vue'),
    ComponentPercent: () => import('../PreparePercent.vue'),
  },

  props: {
    obj: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  width: 100%;
  display: flex;
  border-top: 1px solid darken($color: white, $amount: 15%);

  &__empty {
    font-size: 13px;
    min-width: 35px;
    max-width: 35px;
    align-self: stretch;
    border-right: 1px solid darken($color: white, $amount: 15%);
  }

  &__column {
    width: 100%;
    border-right: 1px solid darken($color: white, $amount: 15%);
    padding: 18px 20px;
    font-size: 13px;
    cursor: default;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:last-child {
      border-right: none;
    }
  }

  &__btn-info {
    border: none;
  }

  //.status,
  //.info,
  //.date,
  //.name {
  //  width: 150px;
  //}
  //
  //.date1,
  //.date2 {
  //  width: 200px;
  //}
  //
  //.translate_name,
  //.category {
  //  width: 310px;
  //}
}
</style>
